import { render, staticRenderFns } from "./QuestionExercise.vue?vue&type=template&id=488a4fcc"
import script from "./QuestionExercise.vue?vue&type=script&lang=js"
export * from "./QuestionExercise.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports